import * as React from "react";
import Button from "@mui/material/Button";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import {
  Divider,
  ListItemIcon,
  ListItemText,
  MenuList,
  TextField,
} from "@mui/material";
import LogoutIcon from "@mui/icons-material/Logout";
import SettingsIcon from "@mui/icons-material/Settings";
import PersonIcon from "@mui/icons-material/Person";
import { useNavigate } from "react-router";
import { Box } from "@mui/system";
import SearchIcon from '@mui/icons-material/Search';
import ManageSearchIcon from '@mui/icons-material/ManageSearch';
import { useState } from "react";
import BlurOnIcon from '@mui/icons-material/BlurOn';

export default function PopupSearch({
  anchorEl,
  open,
  handleClick,
  handleClose,
  ...props
}) {
  const navigate = useNavigate();
  const [taskId,setTaskId]=useState('')
  const [missionId,setMissionId]=useState('')

  const taskIdTextChanged = (event) => {
    if (event.keyCode === 13&&taskId) {
      // document.getElementById("sign_but").click();
      window.open(
        window.location.origin+'/ticket-system/' + `Detials_TaskEdit?id=${taskId}`,
        "_blank"
      );
    }
  };

  function onSearchMissionIdEnter(event) {
    if (event.keyCode === 13&&missionId) {
      // document.getElementById("sign_but").click();
      window.open(
        window.location.origin+'/ticket-system/' + `mission_details?id=${missionId}`,
        "_blank"
      );
    }
  }

  return (
    <Menu
      id="basic-menu"
      anchorEl={anchorEl}
      open={open}
      onClose={handleClose}
      MenuListProps={{
        "aria-labelledby": "basic-button",
      }}
    >
      <Box sx={{width:'100%',paddingLeft:'14px',height:'20px',display:'flex',alignItems:'center'}}>
        <BlurOnIcon sx={{color:'gray',marginRight:'5px'}}/>
         {/* <span style={{fontFamily:'Cairo-Bold'}}>Search</span> */}
      </Box>
      <MenuList
        sx={{
          py: 0,
          px: 1,
          border: "none !important",
          outline: "none !important",
          "& .MuiTypography-root": {
            fontFamily: "Cairo",
          },
          "& .MuiButtonBase-root": {
            padding: "5px 5px !important",
            margin: "5px 0px !important",
            width: "250px",
            height:'55px !important'
          },
          "& .MuiInputBase-root::before": {
            borderBottom:'none !important',
            outline:'none !important',
          },
          "& .MuiInputBase-root.Mui-focused:before": {
            border:'none !important',
            outline:'none !important',
          },
          "& .MuiInputBase-root.Mui-focused:after": {
            border:'none !important',
            outline:'none !important',
          },
          "& .MuiInputBase-root": {
            height:'55px !important',
            borderRadius:'5px !important',
            backgroundColor:'transparent !important'

          },
        }}
      >
        <MenuItem
          disableRipple
        >
          <ListItemIcon>
            <SearchIcon fontSize="medium" />
          </ListItemIcon>
          <TextField
            id="outlined-basic"
            placeholder="Task id.."
            variant="filled"
            sx={{
              margin: "5px 0",
            }}
            value={taskId}
            onKeyDown={taskIdTextChanged}
            onChange={(e)=>{
              if(!isNaN(e?.target?.value)){
                setMissionId('')
                setTaskId(e?.target?.value)
              }
            }}
          />
        </MenuItem>
        <MenuItem
          disableRipple
        >
          <ListItemIcon>
            <ManageSearchIcon fontSize="medium" />
          </ListItemIcon>
          <TextField
            id="outlined-basic"
            placeholder="Mission id ..."
            variant="filled"
            sx={{
              margin: "5px 0",
              border: "none !important",
              outline: "none !important",
            }}
            value={missionId}
            onKeyDown={onSearchMissionIdEnter}
            onChange={(e)=>{
              if(!isNaN(e?.target?.value))
              setMissionId(e?.target?.value)
              setTaskId('')
            }}
          />
        </MenuItem>
      </MenuList>
    </Menu>
  );
}
